import React from 'react'
import { Link } from 'react-router-dom'

const Cart = () => {
    return (
        <>
            <section id="cart" className="cart-main-block">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-4 col-md-6">
                            <div className="cart-shipping-block">
                                <form>
                                    <div className="form-group coupon-form">
                                        <input
                                            type="text"
                                            className="form-control"
                                            id="text"
                                            placeholder="Coupon code"
                                        />
                                        <button type="button" className="btn btn-primary">
                                            Apply
                                        </button>
                                    </div>
                                </form>
                                <div className="calculate-shipping-block">
                                    <h4 className="shipping-heading">Calculate Shipping</h4>
                                    <form>
                                        <div className="form-group">
                                            <input
                                                type="text"
                                                className="form-control"
                                                id="country"
                                                placeholder="United States (US)"
                                            />
                                        </div>
                                        <div className="form-group">
                                            <input
                                                type="text"
                                                className="form-control"
                                                id="state"
                                                placeholder="California"
                                            />
                                        </div>
                                        <div className="form-group">
                                            <input
                                                type="text"
                                                className="form-control"
                                                id="city"
                                                placeholder="City"
                                            />
                                        </div>
                                        <div className="form-group">
                                            <input
                                                type="text"
                                                className="form-control"
                                                id="'pin"
                                                placeholder="Postcode / ZIP"
                                            />
                                        </div>
                                        <button type="button" className="btn btn-primary">
                                            Update
                                        </button>
                                    </form>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-4 col-md-6">
                            <div className="cart-total-amt-block">
                                <h4 className="total-heading">Cart Total</h4>
                                <div className="table-responsive">
                                    <table className="table">
                                        <tbody>
                                            <tr>
                                                <td className="">Subtotal</td>
                                                <td className="price text-end">$33.00</td>
                                            </tr>
                                            <tr>
                                                <td className="">Shipping</td>
                                                <td className="float-end">
                                                    <div className="form-check">
                                                        <input
                                                            className="form-check-input"
                                                            type="radio"
                                                            name="flexRadioDefault1"
                                                            id="flexRadioDefault1"
                                                            defaultChecked=""
                                                        />
                                                        <label
                                                            className="form-check-label"
                                                            htmlFor="flexRadioDefault1"
                                                        >
                                                            Flat rate: <strong>$5.00</strong>
                                                        </label>
                                                    </div>
                                                    <div className="form-check">
                                                        <input
                                                            className="form-check-input"
                                                            type="radio"
                                                            name="flexRadioDefault1"
                                                            id="flexRadioDefault2"
                                                        />
                                                        <label
                                                            className="form-check-label"
                                                            htmlFor="flexRadioDefault2"
                                                        >
                                                            Free shipping
                                                        </label>
                                                    </div>
                                                    Shipping to <strong>CA.</strong>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td className="total-head">Total</td>
                                                <td className="price text-end">$38.00</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                                <Link to="/Checkout" title="" className="btn btn-primary">
                                    Proceed to checkout
                                </Link>
                            </div>
                        </div>
                        <div className="col-lg-4 col-md-12">
                            <div className="cart-button">
                                <div className="row">
                                    <div className="col-lg-6 col-md-6">
                                        <div className="continue-btn">
                                            <Link to="/shop-filter" title="" className="btn btn-primary">
                                                Continue Shopping <i className="flaticon-right-arrows" />
                                            </Link>
                                        </div>
                                    </div>
                                    <div className="col-lg-6 col-md-6">
                                        <div className="update-btn">
                                            <button className="btn btn-primary" type="button">
                                                <i className="flaticon-reload" /> Update Cart
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

        </>
    )
}

export default Cart
